$('#subscribe_modal').on('show', function () {
  var url = $(this).attr("new-form-url");
  $.ajax({
	type: 'GET',
	dataType: 'script',
	url: url
  });
});


function subscribe(email) {
	setTimeout(function() {
		if (window.history && window.history.pushState)
			window.history.replaceState({}, document.title, removeHost(removeQueryStringParameter(window.location.href, "email")));
		$('#subscribe_modal').modal("show");
		$('#subscribe_modal #subscriber_email').val(email);

		setTimeout(function() {
			$('#subscribe_modal form').submit();
		}, 333);
	}, 333);
}
